import http from "@/utils/request";

const itemNoMappingApi = {
  create: (data) =>
    http.sendRequest({
      METHOD_NAME: "itemNoMapping.create",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  pageQuery: (data) =>
    http.sendRequest({
      METHOD_NAME: "itemNoMapping.pageQuery",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  delete: (data) =>
    http.sendRequest({
      METHOD_NAME: "itemNoMapping.delete",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
};

export default itemNoMappingApi;
